import React from 'react';

export const ActionPanelBox = ({ children }: { children: React.ReactNode }) => {
  return <div className="bg-darkblue_10 rounded flex items-center px-4 py-2 gap-2">{children}</div>;
};
